import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

export const abs = (p) => (!p ? undefined : p.startsWith("http") ? p : `${BACKEND}${p}`);

export const money = (n) =>
  `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (typeof x?.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  return d.msg || String(d);
}

export const TYPE_LABELS = {
  physical_art: "Original Artwork",
  digital_art: "Digital Print",
  audio: "Audio",
  video: "Video",
};

export const SHIPPING_LABELS = {
  flat: (p) => `Flat rate · Malaysia ${money(p.shipping_my)} · International ${money(p.shipping_intl)}`,
  malaysia_only: (p) => `Ships within Malaysia only · ${money(p.shipping_my)}`,
  free: () => "Free worldwide shipping",
};

export const COUNTRIES = [
  ["MY", "Malaysia"], ["SG", "Singapore"], ["BN", "Brunei"], ["ID", "Indonesia"], ["TH", "Thailand"],
  ["PH", "Philippines"], ["VN", "Vietnam"], ["AU", "Australia"], ["NZ", "New Zealand"], ["JP", "Japan"],
  ["KR", "South Korea"], ["CN", "China"], ["HK", "Hong Kong"], ["TW", "Taiwan"], ["IN", "India"],
  ["AE", "United Arab Emirates"], ["GB", "United Kingdom"], ["IE", "Ireland"], ["FR", "France"],
  ["DE", "Germany"], ["NL", "Netherlands"], ["BE", "Belgium"], ["ES", "Spain"], ["IT", "Italy"],
  ["PT", "Portugal"], ["CH", "Switzerland"], ["AT", "Austria"], ["SE", "Sweden"], ["NO", "Norway"],
  ["DK", "Denmark"], ["FI", "Finland"], ["PL", "Poland"], ["US", "United States"], ["CA", "Canada"],
  ["MX", "Mexico"], ["BR", "Brazil"], ["ZA", "South Africa"],
];
